import React from 'react'
import { widthRules } from '../../../util/medias'
import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'

const HiddenInComponent = styled.span`
  ${({ mobile, tablet, desktop }) => css`
    display: unset;

    @media (${widthRules.mobile}) {
      display: ${mobile ? 'none' : 'unset'};
    }

    @media (${widthRules.tablet}) {
      display: ${tablet ? 'none' : 'unset'};
    }

    @media (${widthRules.desktop}) {
      display: ${desktop ? 'none' : 'unset'};
    }
  `}
`

const HiddenIn = ({ children, ...props }) => {
  return <HiddenInComponent {...props}>{children}</HiddenInComponent>
}

HiddenIn.propTypoes = {
  mobile: PropTypes.bool,
  tablet: PropTypes.bool,
  desktop: PropTypes.bool,
}

export { HiddenIn }
